import type { BookmarkType } from "@circle-react/types/Bookmarks";

export const BOOKMARK_TAB_VALUES: BookmarkType[] = [
  "post",
  "comment",
  "event",
  "lesson",
  "message",
];
